"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadTreatment = exports.FetchTreatmentActionType = exports.fetchTreatment = exports.LaboratoryActionType = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var LaboratoryActionType = (0, _namespacedKeyMirror.default)({
  FETCH_LABORATORY_TREATMENT: null
}, _constants.LABORATORY);
exports.LaboratoryActionType = LaboratoryActionType;
var fetchTreatment = (0, _fluxActions.createAction)(LaboratoryActionType.FETCH_LABORATORY_TREATMENT, (0, _actions.mapPayloadTo)('data'));
exports.fetchTreatment = fetchTreatment;
var FetchTreatmentActionType = (0, _actions.createRequestTypes)(LaboratoryActionType.FETCH_LABORATORY_TREATMENT);
exports.FetchTreatmentActionType = FetchTreatmentActionType;
var loadTreatment = (0, _actions.createRequestActions)(FetchTreatmentActionType);
exports.loadTreatment = loadTreatment;